import React from 'react';
import styled from 'styled-components';
import Icon from '../Icon';

export default styled(({ side, ...rest }) => <Icon {...rest} />)`
  margin: 0 ${({ side }) => (side === 'left' ? '1rem' : 0)} 0 ${({ side }) => (side === 'right' ? '1rem' : 0)};
  position: relative;
  top: 1px;
  font-size: 1.3rem;
  line-height: 1.5rem;
`;
